import { z } from 'zod';
/**
 * Step Action Type Enum
 * Distinguishes a process step that performs work (`task`) from one that
 * routes based on a decision (`decision`).
 */ export const StepActionTypeSchema = z.enum([
    'task',
    'decision'
]);
/**
 * Whether a step actually has a decision table to draw.
 *
 * One definition for a predicate that was written in three layers — the
 * `renderEntityView` tool's refusal, the chat's no-table card, and the step
 * detail sidebar's own render guard. All three must agree: a step the tool
 * accepts and the sidebar draws must not be one the chat declines to show.
 *
 * Both halves matter. `actionType` alone is not enough (a decision step whose
 * rules were emptied would render a heading over nothing), and `rules.length`
 * alone is not either (the field is optional on every task step).
 */ export function hasDecisionRules(step) {
    return step.actionType === StepActionTypeSchema.enum.decision && (step.rules?.length ?? 0) > 0;
}

//# sourceMappingURL=step-action-type.schema.js.map